module.exports = __webpack_public_path__ + "img/camp.2232f118.png";